export default "__VITE_ASSET__BTgfn24X__"